module.exports = __webpack_public_path__ + "static/media/philanIcon.5c09d6d9.png";